import React from 'react'

import { useInAppNotificationStyles } from '../../../hooks/styles/useInAppNotificationStyles'

const getRelativeTime = (isoTimestamp) => {
  const rtf = new Intl.RelativeTimeFormat('en', {
    numeric: 'auto'
  })

  const now = new Date()
  const then = new Date(isoTimestamp)

  const diffInSeconds = Math.floor((then.getTime() - now.getTime()) / 1000)

  const divisions = [
    { amount: 60, name: 'second' },
    { amount: 60, name: 'minute' },
    { amount: 24, name: 'hour' },
    { amount: 7, name: 'day' },
    { amount: 4.34524, name: 'week' },
    { amount: 12, name: 'month' },
    { amount: Infinity, name: 'year' }
  ]

  let duration = diffInSeconds

  for (const division of divisions) {
    if (Math.abs(duration) < division.amount) {
      return rtf.format(Math.round(duration), division.name)
    }
    duration /= division.amount
  }
}

export const NotificationTime = ({ createdAt, logo }) => {
  const { NotificationTimeTypography } = useInAppNotificationStyles()

  return (
    <NotificationTimeTypography logo={logo}>
      {getRelativeTime(createdAt)}
    </NotificationTimeTypography>
  )
}
